import { ActionStates, buildAsyncActionType } from "reactcoregk/store/actions";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { ApiEndpoint } from "../@core/endpoint";
import { EntityType } from "../@core/entityType";
import {
  ADD_TABLE_SETTINGS,
  GET_ALL_TABLE_SETTINGS,
  GET_THEME_PREFERENCES,
  UPDATE_THEME_PREFERENCES,
} from "./actionTypes";
import {
  addTableSettingActions,
  getAllTableSettingActions,
  getAllThemePreferencesActions,
  updateThemePreferencesActions,
} from "./actions";
import { entityType } from "./module";
import { fetchData, postData } from "helpers/utils";

function* fetchTableSettings() {
  try {
    const url = `${ApiEndpoint[EntityType.UserSettings]}?keys=tableColumns`;
    const results = yield call(fetchData, url);
    yield put(getAllTableSettingActions.success(results));
  } catch (error) {
    yield put(getAllTableSettingActions.failure(error.message));
  }
}

function* newTableSetting({ payload }) {
  try {
    const url = `${ApiEndpoint[EntityType.UserSettings]}?keys=tableColumns`;
    const result = yield call(fetchData, url);
    const body = [
      {
        key: "tableColumns",
        value: {
          ...result[0]?.value,
          [payload.key]: payload.value,
        },
      },
    ];
    yield call(postData, url, body);
    yield put(addTableSettingActions.success(body));
  } catch (error) {
    yield put(addTableSettingActions.failure(error.message));
  }
}

/// Theme changes not required in HC, but keeping it for future reference
function* getThemePreferences() {
  try {
    const url = `${ApiEndpoint[EntityType.UserSettings]}?keys=prefersLightMode`;
    const results = yield call(fetchData, url);
    yield put(getAllThemePreferencesActions.success(results));
  } catch (error) {
    yield put(getAllThemePreferencesActions.failure(error.message));
  }
}

function* updateThemePreferences({ payload }) {
  try {
    const url = `${ApiEndpoint[EntityType.UserSettings]}?keys=prefersLightMode`;
    const body = [
      {
        key: "prefersLightMode",
        value: payload,
      },
    ];
    yield call(postData, url, body);
    yield put(updateThemePreferencesActions.success(body));
  } catch (error) {
    yield put(updateThemePreferencesActions.failure(error.message));
  }
}

export function* watchTableSettings() {
  yield takeEvery(
    buildAsyncActionType(
      entityType,
      GET_ALL_TABLE_SETTINGS,
      ActionStates.request
    ),
    fetchTableSettings
  );
}

export function* watchTableSettingsNew() {
  yield takeEvery(
    buildAsyncActionType(entityType, ADD_TABLE_SETTINGS, ActionStates.request),
    newTableSetting
  );
}
export function* watchThemePreferences() {
  yield takeEvery(
    buildAsyncActionType(
      entityType,
      GET_THEME_PREFERENCES,
      ActionStates.request
    ),
    getThemePreferences
  );
}

export function* watchThemePreferencesChange() {
  yield takeEvery(
    buildAsyncActionType(
      entityType,
      UPDATE_THEME_PREFERENCES,
      ActionStates.request
    ),
    updateThemePreferences
  );
}

function* sagas() {
  yield all([
    fork(watchTableSettings),
    fork(watchTableSettingsNew),
    fork(watchThemePreferences),
    fork(watchThemePreferencesChange),
  ]);
}

export default sagas;
